import {
  deleteChatbotAction,
  getBotChatsAction,
  updateChatbotAction,
} from "../../../../../features/Chatbot/redux/actions";
import {
  setChatbotValue,
  setClearMessages,
} from "../../../../../features/Chatbot/redux/slice";
import { ChatbotValue } from "../../../../api/instances/botApi/types";
import type { ServiceHandler } from "./storageHandlers";

export const chatbotService: ServiceHandler = {
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    listenerApi.dispatch(setChatbotValue(value as ChatbotValue));
    const tgValue = (value as ChatbotValue).tg_bot_object;
    try {
      listenerApi.dispatch(setClearMessages());
      listenerApi.dispatch(getBotChatsAction(tgValue.ref));
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onUpdate(listenerApi, id, value) {
    const { selectedId } =
      listenerApi.getState().storageObjectState.ai_agents_telegram_bots;
    const chatbotValue = value as ChatbotValue;
    if (selectedId === id && chatbotValue) {
      listenerApi.dispatch(updateChatbotAction(chatbotValue.tg_bot_object));
    }
  },
  async onDelete(listenerApi, id, value) {
    if (id === null || value === null) return;
    try {
      const ref = (value as ChatbotValue)?.tg_bot_object.ref;
      if (ref) {
        listenerApi.dispatch(deleteChatbotAction(ref));
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
};
